import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Row, Col } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();

const InformacionSar = () => {
  const id_Usuario = cookies.get("id_Usuario");

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);

  const [formData, setFormData] = useState({
    correlativo: "",
    rangoInicial: "",
    rangoFinal: "",
    fechaLimiteEmision: "",
    rtn: "",
    cai: "",
    idUsuario: id_Usuario,
  });

  const [editingId, setEditingId] = useState(null);

  // Opciones para items por página
  const itemsPerPageOptions = [5, 10, 20, 50];

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  const fetchData = async () => {
    try {
      const token = cookies.get("token");
      const response = await fetch(`${API_HOST}/informacion-sar`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          API: "457896",
        },
      });
      const result = await response.json();
      setData(result);
      setFilteredData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = () => {
    const filtered = data.filter(
      (item) =>
        item.correlativo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.rtn.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.cai.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const validateForm = () => {
    const newErrors = {};

    if (
      !formData.correlativo ||
      formData.correlativo.length < 1 ||
      formData.correlativo.length > 50
    ) {
      newErrors.correlativo =
        "El correlativo debe tener entre 1 y 50 caracteres";
    }

    if (
      !formData.rangoInicial ||
      isNaN(formData.rangoInicial) ||
      formData.rangoInicial < 1
    ) {
      newErrors.rangoInicial = "El rango inicial debe ser un número mayor a 0";
    }

    if (
      !formData.rangoFinal ||
      isNaN(formData.rangoFinal) ||
      formData.rangoFinal < 1
    ) {
      newErrors.rangoFinal = "El rango final debe ser un número mayor a 0";
    }

    if (parseInt(formData.rangoFinal) <= parseInt(formData.rangoInicial)) {
      newErrors.rangoFinal = "El rango final debe ser mayor al rango inicial";
    }

    if (!formData.fechaLimiteEmision) {
      newErrors.fechaLimiteEmision = "La fecha límite de emisión es requerida";
    }

    if (!formData.rtn || formData.rtn.length !== 14) {
      newErrors.rtn = "El RTN debe tener exactamente 14 caracteres";
    }

    if (!formData.cai) {
      newErrors.cai = "El CAI es requerido";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item = null) => {
    if (item) {
      const formattedItem = {
        ...item,
        fechaLimiteEmision: item.fechaLimiteEmision.split("T")[0],
      };
      const {
        idInformacionSar,
        created_at,
        updated_at,
        usuario,
        ...filteredItem
      } = formattedItem;
      setFormData(filteredItem);
      setEditingId(item.idInformacionSar);
    } else {
      setFormData({
        correlativo: "",
        rangoInicial: "",
        rangoFinal: "",
        fechaLimiteEmision: "",
        rtn: "",
        cai: "",
        idUsuario: id_Usuario,
      });
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor corrija los errores en el formulario",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId
      ? `/informacion-sar/${editingId}`
      : "/informacion-sar";
    const dataToSubmit = { ...formData };

    try {
      const bearertoken = cookies.get("token");
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }

      Swal.fire(
        "Éxito",
        editingId ? "Actualizado correctamente" : "Creado correctamente",
        "success"
      );
      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "Hubo un problema en la operación",
        "error"
      );
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/informacion-sar/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });
          Swal.fire("Eliminado!", "El registro ha sido eliminado.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar el registro", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Información SAR</h5>
            <Button
              variant='success'
              onClick={() => handleShowModal()}
              size='sm'
            >
              Agregar Nuevo
            </Button>
          </div>

          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por correlativo, RTN o CAI...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Correlativo</th>
                  <th className='border-top-0'>Rango Inicial</th>
                  <th className='border-top-0'>Rango Final</th>
                  <th className='border-top-0'>RTN</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.idInformacionSar}>
                    <td className='text-muted'>{item.idInformacionSar}</td>
                    <td>{item.correlativo}</td>
                    <td>{item.rangoInicial}</td>
                    <td>{item.rangoFinal}</td>
                    <td>{item.rtn}</td>
                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.idInformacionSar)}
                        className='me-2 action-btn'
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(item)}
                        title='Ver detalles'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {filteredData.length}{" "}
              registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      {/* Modal para agregar/editar */}
      <Modal show={showModal} onHide={handleCloseModal} centered size='lg'>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            {editingId ? "Editar" : "Agregar"} Información SAR
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Correlativo
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='correlativo'
                    value={formData.correlativo}
                    onChange={handleChange}
                    isInvalid={!!errors.correlativo}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.correlativo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> RTN
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='rtn'
                    value={formData.rtn}
                    onChange={handleChange}
                    placeholder='14 caracteres'
                    isInvalid={!!errors.rtn}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.rtn}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Rango Inicial
                  </Form.Label>
                  <Form.Control
                    type='number'
                    name='rangoInicial'
                    value={formData.rangoInicial}
                    onChange={handleChange}
                    min='1'
                    isInvalid={!!errors.rangoInicial}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.rangoInicial}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Rango Final
                  </Form.Label>
                  <Form.Control
                    type='number'
                    name='rangoFinal'
                    value={formData.rangoFinal}
                    onChange={handleChange}
                    min='1'
                    isInvalid={!!errors.rangoFinal}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.rangoFinal}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Fecha Límite de
                    Emisión
                  </Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaLimiteEmision'
                    value={formData.fechaLimiteEmision}
                    onChange={handleChange}
                    isInvalid={!!errors.fechaLimiteEmision}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.fechaLimiteEmision}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> CAI
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='cai'
                    value={formData.cai}
                    onChange={handleChange}
                    isInvalid={!!errors.cai}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.cai}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles de la Información SAR
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Básica</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>ID:</span>{" "}
                    {selectedItem.idInformacionSar}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Correlativo:</span>{" "}
                    {selectedItem.correlativo}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Rango Inicial:</span>{" "}
                    {selectedItem.rangoInicial}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Rango Final:</span>{" "}
                    {selectedItem.rangoFinal}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>RTN:</span> {selectedItem.rtn}
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Información Adicional</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>CAI:</span> {selectedItem.cai}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Fecha Límite Emisión:</span>{" "}
                    {new Date(
                      selectedItem.fechaLimiteEmision
                    ).toLocaleDateString()}
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Registro</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Creado:</span>{" "}
                    {formatDate(selectedItem.created_at)}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Actualizado:</span>{" "}
                    {formatDate(selectedItem.updated_at)}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InformacionSar;
